var map = {
	"./beer.svg": 60,
	"./cases_meldedatum_.csv": 61,
	"./icons__beer_b.png": 62,
	"./icons__beer_b.svg": 63,
	"./icons__beer_is.png": 64,
	"./icons__beer_is.svg": 65,
	"./icons__header_2.png": 66,
	"./icons__header_desk.png": 67,
	"./icons__headerquestion.png": 68,
	"./icons__pattern.png": 69,
	"./icons__row_1.png": 70,
	"./icons__row_2.png": 71,
	"./icons__row_3.png": 72,
	"./icons__snaps_b.png": 73,
	"./icons__snaps_b.svg": 74,
	"./icons__snaps_is.png": 75,
	"./icons__snaps_is.svg": 76,
	"./icons__wine_b.png": 77,
	"./icons__wine_b.svg": 78,
	"./icons__wine_is.png": 79,
	"./icons__wine_is.svg": 80,
	"./icons_arrow_left.png": 27,
	"./icons_arrow_right.png": 28,
	"./icons_arrow_up.png": 29,
	"./icons_beer_b.svg": 81,
	"./icons_beer_is.png": 82,
	"./icons_beer_is.svg": 83,
	"./icons_snaps_b.svg": 84,
	"./icons_snaps_is.png": 85,
	"./icons_snaps_is.svg": 86,
	"./icons_wine_b.svg": 87,
	"./icons_wine_is.png": 88,
	"./icons_wine_is.svg": 89,
	"./illus_amount.svg": 90,
	"./illus_frequency.svg": 91,
	"./illus_risk.svg": 92,
	"./readme.md": 105,
	"./snaps Kopie.svg": 93,
	"./snaps.svg": 94,
	"./wine.svg": 95
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26;